import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'view.VerticalMenu.back',
    defaultMessage: 'Back',
  },
});
